module.exports = __webpack_public_path__ + "img/loginPass.d42e1060.svg";